import React, { useCallback } from 'react';
import { Accordion, ListGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import useProductQueries from '../../hooks/useProductQueries';
import { enableShowMore, selectShowMore } from '../../slices/showMore';
import ProductListSku from './ProductListSku';
import t from '@rcm/i18n-client';
import './ProductList.scss';
import Errors from '../shared/Errors';
import LoadingSpinner from '../shared/LoadingSpinner';

const ProductList = () => {
    const dispatch = useDispatch();

    const showMore = useSelector(selectShowMore);
    const productsQueries = useProductQueries();

    const handleEnableShowMore = useCallback(() => {
        dispatch(enableShowMore());
    }, []);

    return (
        productsQueries.isError ?
            <Errors /> :
        <>
            <Accordion flush>
                {productsQueries.data?.map((product) => (
                    <Accordion.Item eventKey={`${product.id}`} key={product.id}>
                        <Accordion.Header>{product.name}</Accordion.Header>
                        <Accordion.Body>
                            <ListGroup variant="flush">
                                {product.skus.map((sku) => (
                                    <ProductListSku
                                        key={sku.id}
                                        productId={product.id}
                                        skuId={sku.id}
                                    />
                                ))}
                            </ListGroup>
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
                {(!productsQueries.isLoading && !showMore) && <div className="accordion-item">
                    <div className="accordion-header">
                        <button
                            className="accordion-button collapsed show-more"
                            onClick={handleEnableShowMore}
                        >{t("More Products")}</button>
                    </div>
                </div>}
            </Accordion>
            {productsQueries.isFetching && <LoadingSpinner className="text-light" />}
        </>
    );
};

export default ProductList;
